import cx from 'classnames';
import styles from '../../styles/footer.scss';
import { MUTUAL_FUND_RISK_INFO } from '../../constants';
import LowerFooter from './lowerFooter';
import FooterLinks from './footerLinks';

export const Footer = () => (
  <footer className={cx(styles['footer'], 'p20 semibold row')}>
    <FooterLinks />
    <div
      className={cx(
        styles['footer-container'],
        'large-12 small-12 columns pb20'
      )}
    >
      <div className="margin-auto large-12 pl0">
        <div className="large-12 columns footer-pad pl0">
          <div className={cx('mr15', 'pt10', 'border-bottom')}>
            <p className="pt10 pb10 mr15 ct-font-grey queries">
              Got Questions? Write to us at
              <b>
                <a href="mailto:invest@cleartax.in">
                  <i className="fa fa-envelope mr5" /> invest@cleartax.in
                </a>
              </b>
              .
            </p>
          </div>
          <div className="col-xs-12 col-md-3 text-right">
            <a
              className="ml10 ct-font-grey mr10"
              href="https://plus.google.com/+CleartaxIndia/videos"
              target="_blank"
            />
            <a
              className="ml10 ct-font-grey mr10"
              href="https://www.facebook.com/clearfromcleartax"
              target="_blank"
            />
            <a
              className="ml10 ct-font-grey mr10"
              href="https://twitter.com/ClearfromCT"
              target="_blank"
            />
          </div>
        </div>

        <div className={cx('large-12 small-12 columns footer-pad pl0')}>
          <div className="large-12 small-12 columns pl0">
            <p className={cx('ct-font-grey', styles['footer-text'])}>
              {MUTUAL_FUND_RISK_INFO}
            </p>
            <br />
            {/* <p>ClearTax is registered with AMFI under ARN code: ARN110027</p> */}
            <p className={cx('ct-font-grey', styles['footer-text'])}>
              Direct funds are made available by Right Horizons Investment
              Advisory Services Private Limited who is a SEBI registered
              investment advisor with Registration Number: INA200002601, CIN:
              U67190KA2013PTC069720
              <br />
              Address: Arekere, opp, British Biologicals, off Bannerghetta Road,
              Bangalore 560076
            </p>
            <br />
          </div>
        </div>
        <LowerFooter />
        <style jsx>{`
          :global(.footer-pad) {
            padding: 10px 0;
          }
          .large-12 {
            background: #fff;
          }

          .queries a {
            color: #333;
            cursor: pointer;
          }
        `}</style>
      </div>
    </div>
  </footer>
);

export const FooterNew = ({ urlPath }) => (
  <div>
    <div className="lil-bg-font-500 lil-py-6 lil-w-full lil-justify-center lil-flex">
      <div className="lil-container" id="footer">
        <div className="lil-py-4 lil-flex lil-flex-wrap">
          <div className="lil-w-1/6 md:lil-w-1/3 sm:lil-w-1/2">
            <div className="sm:lil-hidden lil-flex lil-items-center lil-mb-10">
              {urlPath &&
              (urlPath['asPath'].indexOf('/mf') === 0 ||
                urlPath['asPath'].indexOf('/mutual-funds') === 0) ? (
                <img
                  width="140"
                  height="21"
                  loading="lazy"
                  src="https://assets1.cleartax-cdn.com/cleartax/images/1642568530_blacklogoframe173341.png"
                  alt="black_logo"
                />
              ) : (
                <img
                  width="150"
                  height="21"
                  loading="lazy"
                  src="https://assets1.cleartax-cdn.com/cleartax/images/1627895294_clearfromctwhite.png"
                  alt="ct_logo"
                />
              )}
            </div>

            <div className="sm:lil-flex lil-items-center lil-mb-5 lil-hidden">
              {urlPath &&
              (urlPath['asPath'].indexOf('/mf') === 0 ||
                urlPath['asPath'].indexOf('/mutual-funds') === 0) ? (
                <img
                  width="130"
                  height="21"
                  loading="lazy"
                  src="https://assets1.cleartax-cdn.com/cleartax/images/1642568530_blacklogoframe173341.png"
                  alt="black_logo"
                />
              ) : (
                <img
                  width="130"
                  height="21"
                  loading="lazy"
                  src="https://assets1.cleartax-cdn.com/cleartax/images/1627895294_clearfromctwhite.png"
                  alt="ct_logo"
                />
              )}
            </div>

            <div className="lil-text-white lil-text-s-14 lil-mb-4">
              <div className="lil-mt-4">Have a query?</div>
              <div className="lil-my-4">
                <a
                  className="lil-underline"
                  href="https://cleartax.in/s/contact-us"
                >
                  Support
                </a>
              </div>
            </div>
          </div>
          <div className="lil-w-1/6 md:lil-w-1/3 sm:lil-w-1/2">
            <div className="lil-text-base lil-font-bold lil-text-font-300">
              Company
            </div>
            <ul className="lil-text-white lil-text-s-14 lil-my-6">
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/about-us">About us</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/meta/contact">Contact us</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/careers">Careers</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/meta/press">Media &amp; Press</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/meta/reviews">User reviews</a>
              </li>
              <li className="lil-my-3">
                <a
                  href="https://medium.com/cleartax-engineering"
                  rel="noopener"
                >
                  Engineering blog
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/v/tax-library/">Clear Library</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/g/terms/">FinTech glossary</a>
              </li>
              <li className="lil-my-3">
                <a href="https://news.cleartax.in/">ClearTax Chronicles</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/gst-product-guides">
                  GST Product Guides
                </a>
              </li>
            </ul>
          </div>
          <div className="lil-w-1/6 md:lil-w-1/3 sm:lil-w-1/2">
            <div className="lil-text-base lil-font-bold lil-text-font-300">
              Individuals
            </div>
            <ul className="lil-text-white lil-text-s-14 lil-my-6">
              <li className="lil-my-3">
                <a href="https://cleartax.in/income-tax-efiling">
                  ClearReturns
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/save">ClearInvestment</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/services/">ClearServices</a>
              </li>
              <li className="lil-my-3">
                <a href="https://play.google.com/store/apps/details?id=in.cleartax.consumer2">
                  Mutual Funds &amp; ITR e-filing App
                </a>
              </li>
            </ul>
            <div className="lil-text-base lil-font-bold lil-text-font-300">
              CAs
            </div>
            <ul className="lil-text-white lil-text-s-14 lil-my-6">
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/ca-partner">
                  CA partner program
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/gst">ClearGST</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartds.com">ClearTDS</a>
              </li>
              <li className="lil-my-3">
                <a href="https://taxcloudindia.com">ClearTaxCloud</a>
              </li>
            </ul>
            <div className="lil-text-base lil-font-bold lil-text-font-300">
              SMEs
            </div>
            <ul className="lil-text-white lil-text-s-14 lil-my-6">
              <li className="lil-my-3">
                <a href="https://cleartax.in/gst">ClearGST</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/clear-app">Clear app Download</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/clearone/">ClearOne</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/gst-billing-software">
                  Billing Software
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/clearone">Invoicing Software</a>
              </li>
            </ul>
            <div className="lil-text-base lil-font-bold lil-text-font-300">
              Enterprises
            </div>
            <ul className="lil-text-white lil-text-s-14 lil-my-6">
              <li className="lil-my-3">
                <a href="https://cleartax.in/gst">ClearGST</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/gst-eway-bill-software">
                  ClearE-Waybill
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/e-invoicing-enterprise-software">
                  e-Invoicing Software
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/tds">ClearTDS</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/gst-eway-bill-registration">
                  eWay Bill Registration
                </a>
              </li>
            </ul>
          </div>
          <div className="lil-w-1/6 md:lil-w-1/3 sm:lil-w-1/2">
            <div className="lil-text-base lil-font-bold lil-text-font-300">
              ITR Resources
            </div>
            <ul className="lil-text-white lil-text-s-14 lil-my-6">
              <li className="lil-my-3">
                <a href="https://cleartax.in/income-tax-efiling">
                  Income Tax efiling
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://play.google.com/store/apps/details?id=in.cleartax.consumer2">
                  Income Tax App android
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/income-tax">Income Tax</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/efiling-income-tax-return">
                  Efiling Income Tax
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/80c-80-deductions">
                  Secion 80 Deductions
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/income-tax-for-nri">
                  Income tax for NRI
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/capital-gains-income">
                  Capital Gains Income
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/house-property">
                  House Property
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/income-tax-e-verification-evc">
                  Income Tax Verification
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/how-to-efile-itr">
                  How to e-file ITR
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/income-tax-refund">
                  Income Tax Refund status
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/tds">File TDS Returns</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/itr">ITR</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/income-tax-slabs">
                  Income Tax Slab
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/view-form-26as-tax-credit-statement">
                  Form 26AS
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/what-is-form-16">
                  What is Form 16
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/salary-income">Salary Income</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/tds/guides">
                  How to File TDS Returns
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/new-income-tax-portal">
                  New Income Tax Portal
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/incometax-gov-inportal">
                  Incometax.gov.in
                </a>
              </li>
            </ul>
            <div className="lil-text-base lil-font-bold lil-text-font-300">
              Mutual Fund Resources
            </div>
            <ul className="lil-text-white lil-text-s-14 lil-my-6">
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/mutual-funds">Mutual funds</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/best-tax-saving-mutual-funds">
                  Best Tax Savings Mutual Funds
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/elss">ELSS funds</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/sip">SIP Mutual Funds</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/tax-handbooks">
                  Guide to tax savings
                </a>
              </li>

              <li className="lil-my-3">
                <a href="https://cleartax.in/mutual-funds/sbi-mutual-fund">
                  SBI Mutual Fund
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/mutual-funds/reliance-mutual-fund">
                  Nippon Reliance mutual fund{' '}
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/mutual-funds/hdfc-mutual-fund">
                  HDFC Mutual Fund
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/mutual-funds/uti-mutual-fund">
                  UTI mutual fund
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/mutual-funds/icici-prudential-mutual-fund">
                  ICICI Prudential Mutual Fund
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/mutual-funds/birla-sun-life-mutual-fund">
                  Aditya Birla Mutual Fund
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/mutual-funds/axis-mutual-fund">
                  Axis mutual fund
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/mutual-funds/motilal-oswal-mutual-fund">
                  Motilal Oswal Mutual Fund
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/mutual-funds/canara-robeco-mutual-fund">
                  Canara Robeco Mutual Fund
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/mutual-funds/kotak-mutual-fund">
                  Kotak Mutual Fund
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/mutual-funds/dsp-mutual-fund">
                  DSP Blackrocks Mutual Fund
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/mutual-funds/lt-mutual-fund">
                  L&amp;T Mutual Fund
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/mutual-funds/edelweiss-mutual-fund">
                  Edelweiss Mutual Fund
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/mutual-funds/mirae-asset-mutual-fund">
                  Mirae Mutual Fund
                </a>
              </li>
            </ul>
          </div>
          <div className="lil-w-1/6 md:lil-w-1/3 sm:lil-w-1/2">
            <div className="lil-text-base lil-font-bold lil-text-font-300">
              Tools
            </div>
            <ul className="lil-text-white lil-text-s-14 lil-my-6">
              <li className="lil-my-3">
                <a href="https://cleartax.in/paytax/taxCalculator">
                  Income tax calculator
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/tax-calculation-gst">
                  GST calculator
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/paytax/hraCalculator">
                  HRA calculator
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/gst-hsn-lookup">Find HSN code</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/save/rent">
                  Generate rent receipts
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/save/sip-calculator">
                  SIP calculator
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/mutual-fund-calculator">
                  Mutual fund calculator
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/gst-number-search/">
                  GST number search
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/fd-calculator">FD Calculator</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/check-status-income-tax-refund">
                  Get IT refund status
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/emi-calculator">
                  EMI Calculator
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/ppf-calculator">
                  PPF Calculator
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/rd-calculator">RD Calculator</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/tax-saving-calculator">
                  Tax Saving Calculator
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/nps-calculator">
                  NPS Calculator
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/home-loan-emi-calculator">
                  Home Loan EMI Calculator
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/gst-hsn-lookup">
                  HSN Code Finder
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/ifsc-code/">IFSC Code Search</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/f/gold-rate/india">
                  Gold Rates Today
                </a>
              </li>
            </ul>

            <div className="lil-text-base lil-font-bold lil-text-font-300">
              Generic Topics
            </div>
            <ul className="lil-text-white lil-text-s-14 lil-my-6">
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/how-to-link-aadhaar-to-pan">
                  How to Link Aadhaar card to PAN
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/uidai">UIDAI</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/pan-card-status">
                  Pan Card Status
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/aadhaar-card">Aadhar card</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/epfo/">EPFO</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/universal-account-number">UAN</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/epf-withdrawal-online">
                  EPF Withdrawal
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/voter-id">Voter ID</a>
              </li>
            </ul>
          </div>
          <div className="lil-w-1/6 md:lil-w-1/3 sm:lil-w-1/2">
            <div className="lil-text-base lil-font-bold lil-text-font-300">
              ClearGST
            </div>
            <ul className="lil-text-white lil-text-s-14 lil-my-6">
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/gst-law-goods-and-services-tax">
                  GST
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/all-about-gst-gov-in-gst-portal">
                  GST Login
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/gst">GST software</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/new-gst-returns">
                  New GST returns
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/e-invoicing-gst">e-invoicing</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/gst-input-tax-credit">
                  Input tax credit
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/gst-law-goods-and-services-tax">
                  GST
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/gst-returns">GST returns</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/gst-invoice">GST invoice</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/services/gst_services/c">
                  GST services
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/gst-calendar">GST calendar</a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/gst-news-and-announcements">
                  GST news
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/invoicing-billing">
                  Invoicing &amp; Billing
                </a>
              </li>
            </ul>
            <div className="lil-text-base lil-font-bold lil-text-font-300">
              ClearServices
            </div>
            <ul className="lil-text-white lil-text-s-14 lil-my-6">
              <li className="lil-my-3">
                <a href="https://cleartax.in/presumptive-tax-for-professionals">
                  Tax filing for professionals
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/tax-filing-for-traders">
                  Tax filing for traders
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/services/startup_services/c">
                  Launch your business
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/services/business/c">
                  Services for businesses
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/trademark-registration-procedure-india">
                  Trademark Registration
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/company-registration">
                  Company Registration
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/services/tds_returns/c">
                  TDS returns
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/clear-launchpad">
                  Clear Launchpad
                </a>
              </li>
              <li className="lil-my-3">
                <a href="https://cleartax.in/s/max-itc">Clear Max ITC</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div
      id="sub-footer"
      className="lil-flex lil-items-center lil-justify-center lil-flex-wrap lil-px-32 sm:lil-px-2 lil-bg-font-400 lil-py-4"
    >
      <div className="lil-pt-2 lil-pb-2 lil-px-8 sm:lil-px-0 lil-text-s-14 lil-text-white lil-flex lil-justify-center">
        <div className="lil-flex lil-my-2 lil-justify-center">
          <a className="lil-px-3" href="https://cleartax.in/meta/terms">
            Terms
          </a>
          <a className="lil-pr-3" href="https://cleartax.in/meta/privacy">
            Privacy
          </a>
          <a href="https://cleartax.in/s/legal">Legal</a>
        </div>
        <div className="lil-flex lil-my-2 lil-justify-center sm:lil-pb-10">
          <a
            className="lil-mr-2 lil-ml-8 sm:lil-mx-2"
            href="https://www.facebook.com/clearfromcleartax"
          >
            <img
              loading="lazy"
              height="24"
              width="24"
              src="https://assets1.cleartax-cdn.com/cleartax/images/1602846766_footer_facebook.png"
              alt="fb"
            />
          </a>
          <a className="lil-mx-2" href="https://twitter.com/ClearfromCT?s=09">
            <img
              loading="lazy"
              height="24"
              width="24"
              src="https://assets1.cleartax-cdn.com/cleartax/images/1602846849_footer_twitter.png"
              alt="twitter"
            />
          </a>
          <a
            className="lil-mx-2"
            href="https://www.linkedin.com/company/cleartaxindia/"
          >
            <img
              loading="lazy"
              height="24"
              width="24"
              src="https://assets1.cleartax-cdn.com/cleartax/images/1602846859_footer_linkedin.png"
              alt="linkedin"
            />
          </a>
          <a className="lil-mx-2" href="https://github.com/ClearTax">
            <img
              loading="lazy"
              height="24"
              width="24"
              src="https://assets1.cleartax-cdn.com/cleartax/images/1602846934_footer_github.png"
              alt="github"
            />
          </a>
          <a
            className="lil-mx-2"
            href="https://www.instagram.com/clearfromcleartax/"
          >
            <img
              loading="lazy"
              height="24"
              width="24"
              src="https://assets1.cleartax-cdn.com/cleartax/images/1602846688_footer_instagram.png"
              alt="instagram"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./components/footer/index.tsx